import * as actionTypes from './actionTypes';
import RequestService from '../service/requestService';

export const fetchDelegationLogError = (error) => {
  return {
    type: actionTypes.FETCH_DELEGATION_LOG_ERROR,
    payload: error
  };
};

export function fetchDelegationLog(sponsorGid, studyGid) {
  return function (dispatch) {
    dispatch(fetchingDelegationLog());
    return RequestService.getDelegationLog(sponsorGid, studyGid)
      .then((response) => {
        dispatch(fetchedDelegationLog(response.data));
      })
      .catch((error) => {
        dispatch(fetchDelegationLogError(error));
      });
  };
}

export const fetchingDelegationLog = () => {
  return {
    type: actionTypes.FETCHING_DELEGATION_LOG
  };
};

export const fetchedDelegationLog = (response) => {
  return {
    type: actionTypes.FETCHED_DELEGATION_LOG,
    payload: response
  };
};
